import type { SVGProps } from 'react';
import * as React from 'react';

const SvgCheckCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    aria-hidden="true"
    fill="currentColor"
    height="100%"
    viewBox="0 0 24 24"
    width="100%"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      clipRule="evenodd"
      d="M12 1.25c5.937 0 10.75 4.813 10.75 10.75S17.937 22.75 12 22.75 1.25 17.937 1.25 12 6.063 1.25 12 1.25m5.03 7.22a.75.75 0 0 0-1.06 0l-5.47 5.47-2.47-2.47-.056-.052A.75.75 0 0 0 6.97 12.53l3 3a.75.75 0 0 0 1.06 0l6-6a.75.75 0 0 0 0-1.06"
      fillRule="evenodd"
    />
  </svg>
);
export default SvgCheckCircle;
